import { Box, Flex, Text } from 'rebass';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import { FaRegEdit } from 'react-icons/fa';
import { RiDeleteBin6Line } from "react-icons/ri";
import Tippy from '@tippy.js/react';
import useSWR from 'swr';

import { BsThreeDots } from "react-icons/bs";

import { createStoryPageAudioCaption, createStoryPageMedium } from '../../story-pages/actions';
import { useToggle } from '../../app/hooks';
import Modal from '../../app/modal/v2';
import TextForm from '../text-form/form';
import textSvg from './assets/text.svg';
import useEntity from 'entities/hooks/use-entity';
import { updateTextMedium } from 'story-media/api';
import { RenderTextEditingForm } from 'stories/story-page-activity/show-transcription';
import 'react-quill/dist/quill.bubble.css';
import { MoreLink } from 'story-media/styled';
import { updateEntity } from 'entities/actions';

const Label = styled.label`
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 8px;
  background: white;
  height: 34px;
  width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const Icon = styled.img`
  height: 32px;
  width: 32px;
`;

const StoryMediumCaption = ({ pageId, enabled, hasAudio, editing, media, ...props }) => {
  const [on, toggle] = useToggle(false);
  const [menuOn, toggleMenu] = useToggle(false);

  const [isEditing, toggleEditing] = useToggle(false);

  const dispatch = useDispatch();
  const { entity } = useEntity(media);
  const { revalidate } = useSWR(`/v2/media/${entity?.id}`)

  if (!enabled || entity?.transcribe) return false;

  return (
    <Flex p={3} sx={{
      borderRadius: '0px 0px 10px 10px',
      background: '#FFF'
    }}>
      {isEditing && <RenderTextEditingForm type={entity?.type} id={entity?.id} values={{ caption: entity?.caption }} onDismiss={toggleEditing} />}

      {/* <Button type="button" variant="transparent" onClick={toggle} mr="auto"> */}
      {entity?.caption ? <Flex width="100%" alignItems="center" justifyContent="space-between">
        <Box bg="white" mt={0} py={0} width="100%" >
          <Text
            fontFamily="Poppins"
            color={"#64748B"}
            fontSize="15px" fontStyle={"italic"}
            lineHeight="150%"
            mt={0}
            dangerouslySetInnerHTML={{ __html: entity?.caption }}
          />
        </Box>
        {editing && <Tippy
          trigger="manual"
          placement="bottom right"
          theme="light"
          interactive
          maxWidth="180px"
          // borderRadius="23px"
          visible={menuOn}
          // style={{
          //   borderRadius: '10px 10px 0px 0px',
          //   background: '#F5EEF8'
          // }}
          content={
            <Box sx={{
              width: '180px',
              flexShrink: 0,
            }}>
              <MoreLink
                onClick={() => {
                  toggle()
                  toggleMenu();
                }}
              >
                <FaRegEdit color="#0E0E0E" size={20} />
                <Text as="span" fontFamily="Poppins" color="#0E0E0E" fontSize={16} >Edit</Text>
              </MoreLink>


              <MoreLink
                color="red"
                borderBottom="none"
                onClick={() => {
                  updateTextMedium(media?.id, {
                    data: {
                      attributes: {
                        caption: null,
                        'lock-version': entity?.['lock-version'],
                      }
                    }
                  })
                  toggleMenu();
                }}
              >
                <RiDeleteBin6Line size={20} />
                <Text as="span" fontFamily="Poppins" color="#0E0E0E" fontSize={16} >Delete</Text>
              </MoreLink>
            </Box>
          }
        >
          <button
            type="button"
            onClick={toggleMenu}
            style={{
              padding: 0,
              border: 'none',
              background: '#fff',
              width: '38px',
              height: '38px',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <BsThreeDots color="#64748B" size={24} />
          </button>
        </Tippy>}
      </Flex>
        : editing ? <Flex alignItems="center" onClick={toggle} color="mutedText">
          <Icon src={textSvg} alt="add a text caption" />
          <Box ml="4px">Add a caption</Box>
        </Flex> : null}
      {/* </Button> */}
      {/* <UserAgent mobile tablet>
        {hasAudio && (
          <Label htmlFor={`${pageId}-audio-caption`}>
            <HiddenFileInput
              id={`${pageId}-audio-caption`}
              accept="audio/*"
              capture="microphone"
              disabled={disabled}
              onChange={e => {
                toggleDisabled();
                const { files } = e.target;
                const audio = Array.from(files)[0];
                props.createStoryPageAudioCaption(pageId, audio).then(toggleDisabled);
              }}
            />
            <Icon src={audioSvg} alt="add an audio caption" />
          </Label>
        )}
      </UserAgent> */}
      {on && (
        <Modal onClose={toggle} closeButton bg="white" maxWidth="414px" closeButtonLeft>
          <Modal.InnerWrap style={{ padding: 0, maxWidth: '414px', margin: "auto", marginTop: '10px' }}>

            <Modal.Title>{entity?.caption ? 'Edit' : 'Add'} a Caption</Modal.Title>
            <Box style={{ background: 'white', display: 'grid', borderRadius: '10px', paddingTop: '30px' }}>

              <Formik
                initialValues={{
                  caption: entity?.caption,
                }}
                validationSchema={Yup.object({
                  caption: Yup.string().test("contains-number", "Caption cannot exceed 84 characters", (value) => {
                    const textOnly = String(value || "").replace(/<[^>]*>/g, '').trim();
                    const characterCount = textOnly.length;
                    return characterCount <= 84;
                  })
                })}
                onSubmit={attributes => {
                  updateTextMedium(media?.id, {
                    data: {
                      attributes: {
                        ...attributes,
                        'lock-version': entity?.['lock-version'],
                      }
                    }
                  })
                    .then(() => revalidate())
                    .then(() => {
                      dispatch(
                        updateEntity({
                          entityType: media?.type,
                          attrs: { caption: attributes?.caption },
                          id: media?.id,
                        })
                      );
                      toggle()
                    });
                }}
                render={fProps => <TextForm showCount name="caption" {...fProps} onCancel={toggle} />}
              />
            </Box>
          </Modal.InnerWrap>
        </Modal>
      )}
    </Flex>
  );
};

StoryMediumCaption.propTypes = {
  enabled: PropTypes.bool.isRequired,
  hasAudio: PropTypes.bool.isRequired,
  pageId: PropTypes.string.isRequired,
  createStoryPageMedium: PropTypes.func.isRequired,
  createStoryPageAudioCaption: PropTypes.func.isRequired,
};

export default connect(null, {
  createStoryPageMedium,
  createStoryPageAudioCaption,
})(StoryMediumCaption);
